import { ApplicationView } from "@mixitone/mvc";

type SectionTabProps = {
  id: string;
  label: string;
  active: boolean;
  onSelect: (id: string) => void;
};

const SectionTab = (props: SectionTabProps) => {
  const { id, label, active, onSelect } = props;

  return (
    <button
      type="button"
      role="tab"
      aria-selected={active}
      onClick={() => onSelect(id)}
      className={`-mb-px cursor-pointer border-b-2 px-0 pb-2 text-sm font-medium transition-colors ${
        active
          ? "border-brand-700 text-brand-700"
          : "border-transparent text-gray-600 hover:border-gray-300 hover:text-gray-900"
      }`}
    >
      {label}
    </button>
  );
};

export default ApplicationView(SectionTab);
